import axios from "axios";
import { AuthRycApiClient } from "./ApiServer";
import { GetApiAddress, SingletonRefreshClient } from "./SingletonRefreshClient";
import { useCallback } from "react";
import { delay } from "../Shared/delay";

export const Authorized = <T,>(token: string | null | undefined): T => {

    const axiosApiInstance = axios.create();

    // Request interceptor for API calls
    axiosApiInstance.interceptors.request.use(

        async config => {
            if (token === null || token === undefined) throw new Error('Token is null or undefined');
            const localToken = localStorage.getItem('token');
            console.log('localToken', localToken, token);
            if (config.headers === undefined) config.headers = {};
            config.headers.Authorization = `Bearer ${localToken ?? token}`;
            config.headers.Accept = 'application/json';
            config.headers['Content-Type'] = 'application/json';
            config.headers['TimeZone'] = Intl.DateTimeFormat().resolvedOptions().timeZone;

            return config;
        },
        error => {
            return Promise.reject(error);
        }
    );

    axiosApiInstance.interceptors.response.use(
        (response) => {
            return response;
        },
        async function (error) {
            const originalRequest = error.config;
            if (error.response.status === 401 && !originalRequest._retry) {
                try {
                    if (error.response.headers['is-token-expired'] === 'true') {
                        if (!SingletonRefreshClient.isRefreshing) {
                            SingletonRefreshClient.setRefresh();
                            originalRequest._retry = true;
                            try {
                                console.log('refresh token', error);
                                await SingletonRefreshClient.refreshToken();
                                console.log('refresh token done');
                            } catch (e) {
                                console.log(e);
                                localStorage.removeItem('token');
                                localStorage.removeItem('refresh_token');
                                window.location.href = window.location.origin;
                            }
                            axios.defaults.headers.common['Authorization'] = 'Bearer ' + localStorage.getItem('token');
                            SingletonRefreshClient.completeRefresh();
                            originalRequest.headers.Authorization = 'Bearer ' + localStorage.getItem('token');
                            console.log('retrying request', originalRequest);
                            return axiosApiInstance(originalRequest);
                        } else {
                            await delay(1500);
                        }
                    } else {
                        throw new Error('unauthorized but refresh token not expires');
                    }
                } catch (e) {
                    console.log('error refresh', e);
                }
            }
            return Promise.reject(error);
        }
    );

    // Assuming you want to return an instance of AuthRycApiClient as T
    return new AuthRycApiClient(GetApiAddress(), axiosApiInstance) as unknown as T;
};